import { template as template_de58dadb146743f4924b7934c6919586 } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import type RenderErrorStateService from '../../services/render-error-state';
interface Signature {
    Args: {
        model?: {
            reason: string;
        };
    };
}
class RenderErrorRouteComponent extends Component<Signature> {
    // The render route handles errors before the child route activates, so we read
    // the serialized payload from the shared service instead of relying on params.
    @service
    renderErrorState: RenderErrorStateService;
    get reason() {
        return this.renderErrorState.reason ?? this.args.model?.reason ?? '';
    }
    static{
        template_de58dadb146743f4924b7934c6919586(`
    <pre
      data-prerender-error
      data-prerender-id={{this.renderErrorState.cardId}}
      data-prerender-nonce={{this.renderErrorState.nonce}}
    >
      {{this.reason}}
    </pre>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default RouteTemplate(RenderErrorRouteComponent);
